import React, { FC } from 'react'

import cn from 'classnames'

import {
  FormControl as MuiFormControl,
  FormLabel,
  FormControlProps,
  FormHelperText,
  makeStyles,
  createStyles
} from '@material-ui/core'

import HebrewText from './HebrewText'
import Text from './Text'

const useStyle = makeStyles(
  (theme) =>
    createStyles({
      label: {
        marginBottom: theme.spacing(1),

        '& span': {
          fontWeight: 500
        }
      },

      smallLabel: {
        fontSize: 14
      }
    }),
  {
    name: 'FormControl'
  }
)

interface Props extends FormControlProps {
  label?: string
  labelHebrew?: string
  errorMessage?: string
  isSmallLabel?: boolean
  isOptional?: boolean
}

const FormControl: FC<Props> = ({
  children,
  label,
  labelHebrew,
  isSmallLabel,
  isOptional,
  errorMessage,
  ...rest
}): JSX.Element => {
  const s = useStyle()

  return (
    <MuiFormControl fullWidth {...rest}>
      <FormLabel
        focused={false}
        filled
        className={cn(s.label, { [s.smallLabel]: isSmallLabel })}
      >
        {!!labelHebrew && (
          <>
            <HebrewText variant="body2" component="span">
              {isOptional && '*'} {labelHebrew}
            </HebrewText>{' '}
          </>
        )}

        <Text variant="body2" component="span">
          {isOptional && '* '} {label}
        </Text>
      </FormLabel>

      {children}

      {!!errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </MuiFormControl>
  )
}

export default FormControl
